import type { AudioPlayerCardActionLink } from "../../types/audio-player-card";

import { TrackableLink } from "../TrackableLink";
import { AudioPlayerCardPlusIcon } from "./AudioPlayerCardPlusIcon";

type AudioPlayerCardPrimaryActionProps = {
  link: AudioPlayerCardActionLink;
};

function AudioPlayerCardPrimaryAction({
  link,
}: AudioPlayerCardPrimaryActionProps) {
  return (
    <TrackableLink
      className="gap-2 font-jakarta font-medium text-sm leading-6 no-underline hover:underline focus-visible:ring-2 focus-visible:ring-ring"
      href={link.url}
      onLinkClick={() => link.onSelect?.()}
      rel="noreferrer"
      size="inline"
      target="_blank"
      variant="plain"
    >
      <AudioPlayerCardPlusIcon />
      {link.label}
      <span className="sr-only">(opens in a new tab)</span>
    </TrackableLink>
  );
}

export { AudioPlayerCardPrimaryAction };
